import * as React from "react";

import debounce from "lodash.debounce";

import "../../../../../../node_modules/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css";

import { handleResizeJQuery, scrollToSelectedDate, setUpCustomScrollbarJQuery } from "../../../scripts/calendarJQueryScript";

import { IEventViewProps } from "../EventView";

import { LoadingIcon } from "../../Common/LoadingIcon/LoadingIcon";
import { MonthListDays } from "./MonthListDays";

import { IDayCell_MonthMobile, IDayCellSlot_MonthMobile } from "../../../classes/dayCell_MonthMobile";

import * as dates from "../../../reducers/changeTimePeriod";
export class MonthlyEventViewMobile extends React.Component<IEventViewProps, any> {

  public constructor(props: any, context: any) {
    super(props, context);
  }

  public componentDidMount() {
    setUpCustomScrollbarJQuery(this.props.portletInstanceId);

    setTimeout(() => {
      window.addEventListener("resize", this.debouncedCallScrollToSelectedDate); // Brief debounce to limit resize from firing more than once every half second.
    });

    this.debouncedCallScrollToSelectedDate();
  }

  public componentDidUpdate() {
    handleResizeJQuery(this.props.portletInstanceId);  // This is required to adjust in case MonthListDays.ts changed the selectedDate from prev/next month back into this month.
    this.debouncedCallScrollToSelectedDate();
  };

  public componentWillUnmount() {
    window.removeEventListener("resize", this.debouncedCallScrollToSelectedDate);
  }

  public render() {

    // Loading and classnames:
    const isLoading = this.props.numAjaxCallsInProgress > 0;
    const loadingEventsText = this.props.text.eventViews.loadingEvents;

    let calViewClass = "CAL-view";
    if (isLoading) { calViewClass += " disabled"; }

    return (
      <div className="CAL-displayArea white_bg">
        <div className={calViewClass}>
          <LoadingIcon displayIcon={isLoading} text={loadingEventsText} />
          <MonthListDays {...this.props} />
        </div>
      </div>
    );
  }

  private callScrollToSelectedDate = () => {
    scrollToSelectedDate(this.props.portletInstanceId);
    this.debouncedCallScrollToSelectedDate.cancel();
  }

  // tslint:disable-next-line:member-ordering
  private debouncedCallScrollToSelectedDate = debounce(this.callScrollToSelectedDate, 250, { leading: false, trailing: true });

};
